import {useState} from "react";
import {useMutation} from "react-query";
import {postObjectData} from "../../../actions/getObjectData";
import {appsDataBaseUrl} from "../../../config/generals";
import _ from "lodash";
import {IAppDataSearch, initAppDataSearch, IValidationErrors} from "./appData.interface";
import {appDataGeneratorContext} from "./appDataGeneratorContext";
import AppDataView from "./appDataReportBuilderView";


const AppsDataManager = () => {


    const validateFields = () => {
        let errors = {} as IValidationErrors;
        if (appDataSearch.dimensions.length === 0) errors.dimensions = 'At least one dimension is required';
        console.log('errors', errors);
        setValidationErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const getReportColumns = (docs: any) => {
        const columns = []
        for (const column of Object.keys(docs[0])) {
            columns.push({name: column, label: column, options: {filter: true, sort: true}})
        }
        return columns;
    }

    const runReport = async (demandWLObj = appDataSearch) => {
        if (!validateFields()) {
            return {reportData: [], reportColumns: [], error: 'Validation error'};
        }
        const docs = await postObjectData(appsDataBaseUrl + '/getAppData', demandWLObj);
        if (_.isEmpty(docs)) return {reportData: [], reportColumns: []};
        const columns = getReportColumns(docs);
        return {reportData: docs, reportColumns: columns};
    }


    const [appDataSearch, setAppDataSearch] = useState<IAppDataSearch>(initAppDataSearch);
    const [validationErrors, setValidationErrors] = useState({} as IValidationErrors);


    const {data: reportData, mutate: mutateReport, isLoading: isLoadingReport} = useMutation('reportData', runReport);


    return (
        <appDataGeneratorContext.Provider
            value={{
                appDataSearch,
                setAppDataSearch,
                runReport: mutateReport,
                reportData: reportData?.reportData,
                reportColumns: reportData?.reportColumns || [],
                isLoadingReport,
                validationErrors,
                setValidationErrors
            }}
        >
            <AppDataView/>
        </appDataGeneratorContext.Provider>
    );
}




export default AppsDataManager;
